(function () {
  // Utility: Debounce function
  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  // Utility: Check if the viewport is mobile
  function isMobileViewport() {
    return window.innerWidth <= 768;
  }

  // Utility: Check if an element is fully in the viewport
  function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  // Utility: Check if an element is partially in the viewport
  function isElementInContainerViewport(el) {
    const rect = el.getBoundingClientRect();
    const windowHeight =
      window.innerHeight || document.documentElement.clientHeight;
    const windowWidth =
      window.innerWidth || document.documentElement.clientWidth;
    return (
      rect.top < windowHeight &&
      rect.bottom > 0 &&
      rect.left < windowWidth &&
      rect.right > 0
    );
  }

  class VideoInteractionHandler {
    constructor() {
      this.debounceWait = 100; // Default debounce wait time in milliseconds
      this.reset = debounce(this.reset.bind(this), this.debounceWait);

      // Initialize event listeners
      window.addEventListener("DOMContentLoaded", this.reset);
      window.addEventListener("beforeunload", this.cleanup.bind(this));
    }

    // Method: Handle hover-play functionality for desktop
    handleHoverPlayOnVideos() {
      if (isMobileViewport()) return;

      const hoverPlayElements = document.querySelectorAll(
        "[js-video-hover-play]"
      );
      hoverPlayElements.forEach((element) => {
        const video = element.querySelector("video");
        if (video) {
          element.addEventListener("mouseenter", () => video.play());
          element.addEventListener("mouseleave", () => {
            video.pause();
            video.currentTime = 0;
          });
        }
      });
    }

    // Method: Handle scroll-play functionality for mobile
    handleScrollPlayOnVideos() {
      if (!isMobileViewport()) return;

      const videoSlider = document.querySelector(".js-video-slider");
      if (!videoSlider) return;

      const handleScroll = debounce(() => {
        if (!isElementInContainerViewport(videoSlider)) return;

        const videos = videoSlider.querySelectorAll("video");
        videos.forEach((video) => {
          if (isElementInViewport(video)) {
            video.play();
          } else {
            video.pause();
          }
        });
      }, this.debounceWait);

      window.addEventListener("scroll", handleScroll);
      videoSlider.addEventListener("scroll", handleScroll);
    }

    // Method: Reset all functionality
    reset() {
      this.handleHoverPlayOnVideos();
      this.handleScrollPlayOnVideos();
    }

    // Method: Clean up event listeners (e.g., before unloading the page)
    cleanup() {
      const hoverPlayElements = document.querySelectorAll(
        "[js-video-hover-play]"
      );
      hoverPlayElements.forEach((element) => {
        const video = element.querySelector("video");
        if (video) {
          element.removeEventListener("mouseenter", () => video.play());
          element.removeEventListener("mouseleave", () => {
            video.pause();
            video.currentTime = 0;
          });
        }
      });
    }
  }

  new VideoInteractionHandler();
})();
